import { render, staticRenderFns } from "./SOV2Detailed.vue?vue&type=template&id=d8c2fce4&scoped=true"
import script from "./SOV2Detailed.vue?vue&type=script&lang=js"
export * from "./SOV2Detailed.vue?vue&type=script&lang=js"
import style0 from "./SOV2Detailed.vue?vue&type=style&index=0&id=d8c2fce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c2fce4",
  null
  
)

export default component.exports